import { Pipe, PipeTransform } from '@angular/core';
import { OrgInviteStatus } from '../../../core/clients/omni-core/models';

@Pipe({
  name: 'inviteStatus',
})
export class SettingsOrganizationInviteStatusPipe implements PipeTransform {
  transform(inviteStatus: OrgInviteStatus['status']): string {
    switch (inviteStatus) {
      case 'PENDING':
        return 'cockpit.settings.members.page.table.pending';
      case 'IN_PROGRESS':
        return 'cockpit.settings.members.page.table.inProgress';
      case 'CANCELLED':
        return 'cockpit.settings.members.page.table.cancelled';
      case 'EXPIRED':
        return 'cockpit.settings.members.page.table.expired';
      case 'FAILURE':
        return 'cockpit.settings.members.page.table.failed';
      case 'OPEN':
        return 'cockpit.settings.members.page.table.open';
      case 'ACCEPTED':
        return 'cockpit.settings.members.page.table.accepted';
    }
  }
}
